import React, {useRef, useState} from 'react'
import {InputDefault} from '../../../../components/ui'
import {FieldArray, FormikProvider, useFormik} from 'formik'
import {ProductSchema} from '../../../../modules/helperValidation'

interface Props {
  handleChange: (e: any) => void
  id?: string
  initLoad?: any
  loadings?: any
  percent?: any
  idr?: any
}

const FormProduct: React.FC<Props> = ({handleChange, id, initLoad, loadings, percent, idr}) => {
  const resetForms = useRef<any>(null)
  const [globalPercent, setGlobalPercent] = useState(false)
  const initValue = {
    sku: '',
    name: '',
    product_detail: '',
    description: '',
    link: '',
    transaction_value: '',
    point: 0,
    images: [{
      path: '',
    }],
    globalPercents: globalPercent,
    parcent: globalPercent ? percent : '',
  }
  const formik = useFormik({
    initialValues: id ? initLoad : initValue,
    onSubmit: (values, {resetForm}) => {
      handleChange(values)
    },
    enableReinitialize: true,
    // validationSchema: ProductSchema,
  })

  const countPoint = () => {
    const point =
      ((parseInt(formik.values.parcent) / 100) * parseInt(formik.values.transaction_value)) /
        parseInt(idr) || 0
    formik.setFieldValue('point', point)
  }
  return (
    <FormikProvider value={formik}>
    <form onSubmit={formik.handleSubmit} ref={resetForms}>
      <div className='form-check form-check-solid form-switch fv-row d-flex justify-content-end'>
        <input
          className='form-check-input w-40px h-20px'
          type='checkbox'
          name='globalPercents'
          onChange={(e) => {
            formik.setFieldValue('globalPercents', e.target.checked)
            setGlobalPercent(e.target.checked)
          }}
          defaultChecked={formik.values.globalPercents}
        />
        <label className='form-check-label'>
          <span className=' fs-6 m-3'>Global Percentage</span>
        </label>
      </div>
      <div className='d-flex flex-column align-items-center gap-4'>
        <div className='mb-3 w-100'>
          <label htmlFor='sku' className='form-label m-2'>
            SKU
          </label>
          <InputDefault
            type='text'
            id='sku'
            name='sku'
            onChange={formik.handleChange}
            value={formik.values.sku}
            validation={formik.errors.sku && formik.touched.sku}
            textError={formik.errors.sku}
          />
          <label htmlFor='name' className='form-label m-2'>
            Product Packages
          </label>
          <InputDefault
            type='text'
            id='name'
            name='name'
            onChange={formik.handleChange}
            value={formik.values.name}
            validation={formik.errors.name && formik.touched.name}
            textError={formik.errors.name}
          />
          <label htmlFor='product_detail' className='form-label m-2'>
            Detail Product
          </label>
          <InputDefault
            type='text'
            id='product_detail'
            name='product_detail'
            onChange={formik.handleChange}
            value={formik.values.product_detail}
            validation={formik.errors.product_detail && formik.touched.product_detail}
            textError={formik.errors.product_detail}
          />
          <label htmlFor='description' className='form-label m-2'>
            Description
          </label>
          <InputDefault
            type='text'
            id='description'
            name='description'
            onChange={formik.handleChange}
            value={formik.values.description}
            validation={formik.errors.description && formik.touched.description}
            textError={formik.errors.description}
          />
          <label htmlFor='link' className='form-label m-2'>
            Link
          </label>
          <InputDefault
            type='text'
            id='link'
            name='link'
            onChange={formik.handleChange}
            value={formik.values.link}
            validation={formik.errors.link && formik.touched.link}
            textError={formik.errors.link}
          />
          <label htmlFor='transaction_value' className='form-label m-2'>
            Price
          </label>
          <InputDefault
            type='number'
            id='transaction_value'
            name='transaction_value'
            onChange={(e) => {
              formik.handleChange(e)
              countPoint()
            }}
            value={formik.values.transaction_value}
            validation={formik.errors.transaction_value && formik.touched.transaction_value}
            textError={formik.errors.transaction_value}
          />
          <div className='mt-4  d-flex justify-content-md-between'>
            <label htmlFor='point' className='form-label mr-2 d-flex p-2'>
              <span className='form-check-label d-flex flex-column align-items-start'>
                <span className=' fs-6'>Point (%)</span>
              </span>
            </label>
            <span className='form-label m-2 mr-2 d-flex '>
              <span className=' fs-5 mb-5'>{`Point gain : ${formik.values.point} Pts`}</span>
            </span>
          </div>
          <InputDefault
            type='number'
            id='parcent'
            name='parcent'
            onChange={(e) => {
              formik.handleChange(e)
              countPoint()
            }}
            value={formik.values.parcent}
            readOnly={globalPercent ? true : false}
            validation={formik.errors.parcent && formik.touched.parcent}
            textError={formik.errors.parcent}
          />
          {id ? null : (
            <>
              <FieldArray
                name='images'
                render={(arrayHelpers) => (
                  <>
                  {formik.values.images.map((e:any, index: any) =>(
                    <>
                    <label className='form-label m-2'>
                         Image {index + 1}
                      </label>
                      <InputDefault
                        type='file'
                        id={`images[${index}].path`}
                        name={`images[${index}].path`}
                        onChange={(e) => formik.setFieldValue(`images[${index}].path`, e.target.files![0])}
                        // value={formik.values.images[index].path}
                      />
                       <div className='col-lg-6 fv-row mt-2'>
                          {index !== 0 && <button
                            className='btn btn-danger'
                            type="button"   
                            onClick={() => arrayHelpers.remove(index)}        
                          >
                           -
                          </button>} 
                        </div>
                    </>
                  ))}
                  <div className='col-lg-6 fv-row mt-5'>
                    <button
                      className='btn btn-success'
                      onClick={() => arrayHelpers.push({path: ''})}  
                      type="button"     
                    >
                      +
                    </button>
                  </div>
                      
                  </>
                )}
              />
              
            </>
          )}

          <div className='card-footer d-flex justify-content-end py- px-'>
            {!loadings ? (
              <button
                onClick={() => console.log(formik.values)}
                className='btn btn-primary'
                data-bs-target='#add-edit-member'
                type='submit'
              >
                Submit
              </button>
            ) : (
              <button className='btn btn-primary' data-kt-indicator='on' type='button'>
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
    </FormikProvider>
  )
}

export default FormProduct
